var map = {
	"./CB0000_rabbit_stroke.png": "736a",
	"./CB0010_bear_stroke.png": "bba8",
	"./CB0020_cat_stroke.png": "0c5d",
	"./CB0030_hamster_stroke.png": "50ef"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4d05";